
import {tap} from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

import { EventService } from '../services/internal/event-service';
import { SPOTTER_ENV } from '@spotter/tokens/env.token';
import { SpotterEnvironment } from '@spotter/environments/environment.template';



@Injectable()
export class SpotterHttpInterceptor implements HttpInterceptor {

    constructor(public errorHandler: EventService, @Inject(SPOTTER_ENV) private env: SpotterEnvironment) {}

    // We intercept all requests to handle errors and change the correct environment API path
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       let modifiedRequest = request;
        
        // Send all API requests to the correct URL based on the environment
        if (request.url.startsWith("/api"))
        {
            let requestedPath = request.url.slice(4);
            modifiedRequest = request.clone({ url: this.env.apiURL+requestedPath, withCredentials: true });  
        }


        // Send the request and emit relevant errors
        return next.handle(modifiedRequest).pipe(tap({
            next: (event: HttpEvent<any>) => {},
            error: (err: any) => {
                if (err instanceof HttpErrorResponse)
                {
                    // Convert any errors that aren't plain messages
                    if (typeof(err.error) == 'object')
                    {
                        //@ts-ignore
                        err.error = err.statusText + ` (${err.status})`;

                        if (err.status == 0)
                        {
                            //@ts-ignore
                            err.error = "No Internet";
                        }
                            
                    }
                    else if (typeof(err.error) == 'string')
                    {
                        // Convert HTML server responses to a string with the title
                        if (err.error.includes("<head><title>"))
                        {
                            const res = new RegExp("<title>(.+?)</title>").exec(err.error);
                            if (res)
                            {
                                //@ts-ignore
                                err.error = res[1];
                            }
                            
                        }
                    }

                    // Todo: Handle 403s
                    if (err.status == 401)
                        this.errorHandler.fail401.emit(err);
                    else if (err.status == 404)
                        this.errorHandler.fail404.emit(err);
                    else if (err.status == 419)
                        this.errorHandler.fail419.emit(err);
                    else if (err.status == 429)
                        this.errorHandler.fail429.emit(err);

                    else if (err.status == 500)
                        this.errorHandler.fail500.emit(err);
                    else if (err.status == 503)
                        this.errorHandler.fail503.emit(err);

                    else if (err.status == 0)
                        this.errorHandler.noInternet.emit(err);

                }
            }
        }));
        

      
      
    }
}
